<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size sm_size">
                <a href="javascript:" class="ui_close" type="button" @click="onClose()">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <slot name="header">
                            {{ $t('FIELD.EVALUATE.TITLE') }}
                        </slot>
                    </dt>
                    <dd>
                        <div class="opinion_wrap">
                            <p class="q_opinion">{{ $t('MESSAGE.FIELD.SATISFIED') }}</p>
                            <ul class="opinion_list">
                                <li @click="score($event, 5)">{{ $t('TITLE.GLOBAL.LABEL.VERYSATISFIED') }}</li>
                                <li @click="score($event, 4)">{{ $t('TITLE.GLOBAL.LABEL.SATISFIED') }}</li>
                                <li @click="score($event, 3)">{{ $t('TITLE.GLOBAL.LABEL.NORMAL') }}</li>
                                <li @click="score($event, 2)">{{ $t('TITLE.GLOBAL.LABEL.BAD') }}</li>
                                <li @click="score($event, 1)">{{ $t('TITLE.GLOBAL.LABEL.VERYBAD') }}</li>
                            </ul>
                            <!-- 
                            <p class="q_opinion">Send your opinion</p>
                            <div class="opinion_textarea">
                                <textarea
                                    class="textarea_ty w100p"
                                    placeholder="Send your opinion"
                                    v-model="ansReason"
                                ></textarea>
                            </div>
                             -->
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.APPLY') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import ToastGrid from '~c/ToastGrid';

export default {
    name: 'evaluatePopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        target: {
            type: String,
            default: '',
        },
        questionId: {
            type: String,
            default: '',
        },
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'evaluatePopup',
            ansScore: 0,
            ansReason: '',
        };
    },
    mounted() {
        // this.onSearch(this.param);
    },
    methods: {
        score(e, v) {
            $('.opinion_list li').removeClass('active');
            $(e.target).addClass('active');
            this.ansScore = v;
        },
        onSave() {
            let MENDATORY = SDLUtil.getMsgProp('MESSAGE.FIELD.CHECK.MENDATORY');
            if (0 === this.ansScore) {
                return SDLUtil.alert(MENDATORY.replace('{0}', 'My Satisfaction'));
            }

            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionEval.skp`,
                    qs.stringify({
                        questionId: this.questionId,
                        ansScore: this.ansScore,
                        ansReason: this.ansReason,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.QNA.EVALUATION.SUCCESS'));
                    return this.onPageMove();
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onPageMove() {
            this.rtnFunc(this.target, this.questionId);
            this.$emit('close');
        },
        onClose() {
            SDLUtil.confirm({
                msg: 'Want to close without apply?',
                onOkEvt: () => {
                    this.$emit('close');
                },
            });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/evaluatePopup.vue